import { get } from '@/lib/api';

/** 获取路由 */
export const getRouters = () => {
  return get('/system/menu/getRouters/info', {});
};
